var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"category"},[_c('Header',{staticClass:"category__header",on:{"change":_vm.changeTab}}),_c('main',{staticClass:"category__main"},[_c('a-list',{attrs:{"pagination":_vm.pagination,"grid":{ gutter: 16, xs: 1, sm: 2, md: 2, lg: 3, xl: 4, xxl: 6 },"data-source":_vm.categorys,"locale":{
        emptyText: _vm.showActive
          ? '暂无分类，点击页面右上角添加分类吧'
          : '没有归档的分类'
      }},scopedSlots:_vm._u([{key:"renderItem",fn:function(item){return _c('a-list-item',{},[_c('CategoryCard',{attrs:{"category":item}})],1)}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }